import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerSupportMessage } from 'src/app/interfaces/customer-support-message';
import { CustomerSupportService } from 'src/app/services/customer-support.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss'],
    standalone: false
})
export class ContactFormComponent {
     @Input() contactFormInfo?: CustomerSupportMessage;


     contactName: string = '';
     email: string = '';
     phoneNumber: string = '';
     topic: string = '';
     message: string = '';
     topicIn:string = '';
    
     messageSentSuccess = false;
     messageSentError = false;
     sendingMessage = false;
     showLoginHelp = false;
     disabledTopic = false;
     contactInfo!:FormGroup;

     @ViewChild('LoginHelpModal') loginHelpModal: ElementRef | undefined;

     constructor(public generalService: GeneralService, 
          public customerSupportService: CustomerSupportService, 
          private modalService: NgbModal) { 
          
     }

     ngOnInit(): void {
          if(this.contactFormInfo != undefined){
               this.message = this.contactFormInfo.message;
               this.topic = this.contactFormInfo.topic;
               this.topicIn = this.contactFormInfo.topic;
               this.email = this.contactFormInfo.contactEmail
               this.phoneNumber = this.contactFormInfo.contactPhone
               this.contactName = this.contactFormInfo.contactName
               this.disabledTopic = true;
          }
          this.contactInfo = new FormGroup({
               contactName: new FormControl(this.contactName, [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.pattern(/^([a-zA-Z ']*)$/) 
               ]),
               email: new FormControl(this.email, [
                    Validators.required,
                    Validators.maxLength(100),
                    Validators.pattern(/^[-a-z0-9'!_-}{\'?]+(\.[-a-z0-9'!_-}{\'?]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_-]+\.)+[a-zA-Z]{2,}))$/) 
               ]),
               phoneNumber: new FormControl(this.phoneNumber, [
                    Validators.required,
                    Validators.minLength(10),
                    Validators.pattern(/^\d{10}$/)
               ]),
               topic: new FormControl({value:this.topic, disabled: this.disabledTopic}, [
                    Validators.required
                    
               ]),
               message: new FormControl(this.message, [
                    Validators.required,
                    Validators.maxLength(1000),
                    Validators.pattern(/^([a-zA-Z0-9 \n \r '.?@,-]*)$/) 
               ])
          });  
          this.scrollToTop();
     }
     get contactName_() { return this.contactInfo!.get('contactName'); }
     get email_() { return this.contactInfo!.get('email'); }
     get phoneNumber_() { return this.contactInfo!.get('phoneNumber'); }
     get topic_() { return this.contactInfo!.get('topic'); }
     get message_() { return this.contactInfo!.get('message'); }

     get isValued(){
          return (this.contactName_?.valid && this.email_?.valid && this.phoneNumber_?.valid && (this.topic_?.valid || this.disabledTopic) && this.message_?.valid ? '' : 'true')
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }


     topicChanged() {
          this.topic = this.contactInfo!.get('topic')?.value;
          if (this.topic?.toLocaleLowerCase() === 'login') {
               this.showLoginHelp = true;
               this.modalService.open(this.loginHelpModal, { ariaLabelledBy: 'loginHelpModalTitle' });
          }
     }

     hideLoginHelp() {
          this.showLoginHelp = false;
          this.modalService.dismissAll();
     }

     sendMessage() {
          if (this.contactName_!.value && this.email_!.value && this.message_!.value && this.topic_!.value && this.phoneNumber_!.value) {
               this.sendingMessage = true;
               const message: CustomerSupportMessage = {
                   contactEmail: this.email_?.value,
                   contactName: this.contactName_?.value,
                   contactPhone: this.phoneNumber_?.value,
                   message: this.message_?.value,
                   topic: this.topic_?.value
               }
               this.scrollToTop();
               const isSuccess = this.customerSupportService.sendCustomerSupportMessage(message);
               isSuccess.subscribe((v: any) => this.updateMessageSent(v));
          }
      }
  
      updateMessageSent(success: boolean | any) {
          this.sendingMessage = false;
  
          if (success && success === true) {
              this.messageSentSuccess = true;
          } else {
              this.messageSentError = true;
          }
      }

   

}
